export default __webpack_public_path__ + "media/main_banner.2ee6f2f3.png";